export const codeSnippet = {
    code1: `const memoizedValue = React.useMemo(() => computeExpensiveValue(a, b), [a, b]);`,
    code2: `const List = React.useMemo(() => 
listOfItems.map(item => ({
  ...item,
  itemProp1: expensiveFunction(props.first),
  itemProp2: anotherPriceyFunction(props.second) 
})), [listOfItems])`,
	code3: `const arr = [1, 2, 3]`,
	code4: `const themeStyles = {
  backgroundColor: dark ? "black" : "white",
  color: dark ? "white" : "black"
}
useEffect(() => {}, [themeStyles])`,
code5: `const themeStyles = usememo(() => {
 return {
   backgroundColor: dark ? "black" : "white",
   color: dark ? "white" : "black"
  }
}, [dark])

useEffect(() => {}, [themeStyles])`,
  code6: `import { useMemo } from 'react';

function ItemList({ items, filter }) {
  // Use the useMemo hook to memoize the filtered items
  const filteredItems = useMemo(() => {
    return items.filter(item => item.name.includes(filter));
  }, [items, filter]);

  return (
    <ul>
      {filteredItems.map(item => (
        <li key={item.id}>{item.name}</li>
      ))}
    </ul>
  );
}`,
  code7: `import { useState, useMemo } from 'react';

function ProductList() {
  const [products] = useState([
    { id: 1, name: 'Laptop', price: 1200, category: 'Electronics' },
    { id: 2, name: 'Phone', price: 800, category: 'Electronics' },
    { id: 3, name: 'Book', price: 25, category: 'Education' },
    { id: 4, name: 'Headphones', price: 150, category: 'Electronics' },
    // ... thousands of products
  ]);

  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('name');
  const [filterCategory, setFilterCategory] = useState('all');

  // Expensive filtering and sorting - only runs when dependencies change
  const filteredAndSortedProducts = useMemo(() => {
    console.log('Filtering and sorting products...');
    
    let filtered = products;

    // Filter by search term
    if (searchTerm) {
      filtered = filtered.filter(product =>
        product.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Filter by category
    if (filterCategory !== 'all') {
      filtered = filtered.filter(product => product.category === filterCategory);
    }

    // Sort products
    filtered.sort((a, b) => {
      if (sortBy === 'price') {
        return a.price - b.price;
      }
      return a.name.localeCompare(b.name);
    });

    return filtered;
  }, [products, searchTerm, sortBy, filterCategory]);

  return (
    <div>
      <div>
        <input
          type="text"
          placeholder="Search products..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        
        <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
          <option value="name">Sort by Name</option>
          <option value="price">Sort by Price</option>
        </select>
        
        <select value={filterCategory} onChange={(e) => setFilterCategory(e.target.value)}>
          <option value="all">All Categories</option>
          <option value="Electronics">Electronics</option>
          <option value="Education">Education</option>
        </select>
      </div>

      <div>
        {filteredAndSortedProducts.map(product => (
          <div key={product.id}>
            <h3>{product.name}</h3>
            <p>Price: $product.price</p>
            <p>Category: {product.category}</p>
          </div>
        ))}
      </div>
    </div>
  );
}`
}

